// Shown after "Suspend my code": the person is signed out everywhere. They can
// sign in again and reactivate the code themselves (FR-31) unless the platform
// put an admin hold on the account; then support helps.
import { Anchor, Text } from "@mantine/core";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useBrand } from "../../shared/brand/brand";
import { clearSession } from "../../shared/session/session";
import { Page } from "../../shared/ui/Page";

export function SuspendedPage() {
  const { t } = useTranslation();
  const brand = useBrand();
  const signOut = (useLocation().state as { signOut?: boolean } | null)?.signOut === true;
  // The server already ended every session; forget the access token here too.
  useEffect(() => {
    if (signOut) clearSession();
  }, [signOut]);
  return (
    <Page title={t("suspended.title")}>
      <Text data-testid="suspended">{t("suspended.body")}</Text>
      <Text size="sm">{t("suspended.support", { email: brand.support.email, phone: brand.support.phone })}</Text>
      <Anchor component={Link} to="/signin">
        {t("suspended.sign_in")}
      </Anchor>
      <Anchor component={Link} to="/">
        {t("suspended.home")}
      </Anchor>
    </Page>
  );
}
